export default __webpack_public_path__ + "assets/images/icon-brush-cursor-1.a9c6c8e5a676ddb2ed333fd942d751c1.svg";